import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Box } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../app/hooks';
import MapIconStyleWrapper from '../../../map/MapIconStyleWrapper';
import {
  selectIsOpenBlockBoundaryDialog,
  setIsOpenBlockBoundaryDialog,
} from '../../onboardingSlice';

const OpenBlockBoundaryFormButton: React.FC = () => {
  const dispatch = useAppDispatch();
  const isOpenBlockBoundaryDialog = useAppSelector(
    selectIsOpenBlockBoundaryDialog
  );

  const handleClick = () => {
    dispatch(setIsOpenBlockBoundaryDialog(!isOpenBlockBoundaryDialog));
  };

  return (
    <Box>
      <MapIconStyleWrapper
        icon={<OpenInNewIcon />}
        showClickableCursor
        handleOnClick={handleClick}
      />
    </Box>
  );
};

export default OpenBlockBoundaryFormButton;
